export default __webpack_public_path__ + "static/media/avrk_banner.7125cbc2.jpeg";